import * as actionTypes from 'src/constants/actionTypes'

/**
 * `DYNATRACE_ACTIONS` - Represents various actions related to customer solutions.
 * If mapped to `false`, it means they are instant actions
 * If mapped to an object with `success`/`failure`, that indicates which action
 * will mark the conclusion of the initial one
 */
const DYNATRACE_ACTIONS = {
    [actionTypes.SEARCH_CUSTOMERS]: {
        success: actionTypes.SEARCH_CUSTOMERS_SUCCESS,
        failure: actionTypes.SEARCH_CUSTOMERS_ERROR,
    },
    [actionTypes.SEARCH_CUSTOMERS_CLEAR]: false,
    [actionTypes.GET_CUSTOMER_SOLUTIONS]: {
        success: actionTypes.GET_CUSTOMER_SOLUTIONS_SUCCESS,
        failure: actionTypes.GET_CUSTOMER_SOLUTIONS_ERROR,
    },
    [actionTypes.SET_SOLUTIONS_CUSTOMER]: false,
    [actionTypes.CLEAR_SELECTED_CUSTOMER]: false,
    [actionTypes.STORE_CUSTOMER_SOLUTIONS]: {
        success: actionTypes.STORE_CUSTOMER_SOLUTIONS_SUCCESS,
        failure: actionTypes.STORE_CUSTOMER_SOLUTIONS_ERROR,
    },
    [actionTypes.SELECT_CMDB_CI_FILTER]: false,
    [actionTypes.SELECT_CMDB_FILTER_VALUE]: false,
    [actionTypes.GET_CUSTOMER_SOLUTIONS_RUNBOOK]: {
        success: actionTypes.GET_CUSTOMER_SOLUTIONS_RUNBOOK_SUCCESS,
        failure: actionTypes.GET_CUSTOMER_SOLUTIONS_RUNBOOK_ERROR,
    },
    [actionTypes.SEARCH_DEVICES]: {
        success: actionTypes.SEARCH_DEVICES_SUCCESS,
        failure: actionTypes.SEARCH_DEVICES_ERROR,
    },
    [actionTypes.SEARCH_DEVICES_CLEAR]: false,
    [actionTypes.REFRESH_SOLUTION]: {
        success: actionTypes.REFRESH_SOLUTION_SUCCESS,
        failure: actionTypes.REFRESH_SOLUTION_ERROR,
    },
    [actionTypes.PROCESS_ENQUEUED_REFRESH]: false,
    [actionTypes.SEARCH_CMDB_CLASS]: {
        success: actionTypes.SEARCH_CMDB_CLASS_SUCCESS,
        failure: actionTypes.SEARCH_CMDB_CLASS_ERROR,
    },
    [actionTypes.SET_DEPTH_LEVEL]: false,
    [actionTypes.TOGGLE_RUNBOOKS_ACCESS_TYPE]: false,
    [actionTypes.TOGGLE_RUNBOOKS_ENVIRONMENT]: false,
    [actionTypes.SET_CUSTOMER_FILTER]: false,
    [actionTypes.CHANGE_RUNBOOKS_PAGE]: false,
    [actionTypes.GET_RUNBOOKS]: {
        success: actionTypes.GET_RUNBOOKS_SUCCESS,
        failure: actionTypes.GET_RUNBOOKS_ERROR,
    },
    [actionTypes.GET_RUNBOOK]: {
        success: actionTypes.GET_RUNBOOK_RECEIVED,
        failure: actionTypes.GET_RUNBOOK_ERROR,
    },
    [actionTypes.RESET_CREATE_RUNBOOK]: false,
    [actionTypes.CREATE_RUNBOOK]: false,
    [actionTypes.UPDATE_RUNBOOK]: false,
    [actionTypes.DELETE_MARKED_ACTIONS]: false,
    [actionTypes.UPDATE_RUNBOOK_SERVER]: {
        success: actionTypes.UPDATE_RUNBOOK_SERVER_RECEIVED,
        failure: actionTypes.UPDATE_RUNBOOK_SERVER_ERROR,
    },
    [actionTypes.START_FORECASTING]: false,
    [actionTypes.EDIT_RUNBOOK_ACTIONS]: {
        success: actionTypes.EDIT_RUNBOOK_ACTIONS_RECEIVED,
        failure: actionTypes.EDIT_RUNBOOK_ACTIONS_ERROR,
    },
    [actionTypes.UPDATE_RUNBOOK_SESSION_ACTIONS]: {
        success: actionTypes.UPDATE_RUNBOOK_SESSION_ACTIONS_RECEIVED,
        failure: actionTypes.UPDATE_RUNBOOK_SESSION_ACTIONS_ERROR,
    },
    [actionTypes.COPY_RUNBOOK_SERVER]: {
        success: actionTypes.COPY_RUNBOOK_SERVER_RECEIVED,
        failure: actionTypes.COPY_RUNBOOK_SERVER_ERROR,
    },
    [actionTypes.EXPORT_RUNBOOK]: false,
    [actionTypes.EXPORT_RUNBOOK_LEGACY]: false,
    [actionTypes.SET_ACTIVE_RUNBOOK]: false,
    [actionTypes.DELETE_RUNBOOK]: {
        success: actionTypes.DELETE_RUNBOOK_RECEIVED,
        failure: actionTypes.DELETE_RUNBOOK_ERROR,
    },
    [actionTypes.OPEN_SUPPLIER_MODAL]: false,
    [actionTypes.CLOSE_SUPPLIER_MODAL]: false,

    [actionTypes.SAVE_SUPPLIER]: {
        success: actionTypes.SAVE_SUPPLIER_SUCCESS,
        failure: actionTypes.SAVE_SUPPLIER_ERROR,
    },
    [actionTypes.DELETE_SUPPLIER]: {
        success: actionTypes.DELETE_SUPPLIER_SUCCESS,
        failure: actionTypes.DELETE_SUPPLIER_ERROR,
    },

    [actionTypes.GET_SUPPLIERS]: {
        success: actionTypes.GET_SUPPLIERS_SUCCESS,
        failure: actionTypes.GET_SUPPLIERS_ERROR,
    },

    [actionTypes.GET_CMDB_CONTACTS]: {
        success: actionTypes.GET_CMDB_CONTACTS_SUCCESS,
        failure: actionTypes.GET_CMDB_CONTACTS_ERROR,
    },

    [actionTypes.SAVE_CMDB_CONTACT]: {
        success: actionTypes.SAVE_CMDB_CONTACT_SUCCESS,
        failure: actionTypes.SAVE_CMDB_CONTACT_ERROR,
    },

    [actionTypes.GET_CMDB_TEAMS]: {
        success: actionTypes.GET_CMDB_TEAMS_SUCCESS,
        failure: actionTypes.GET_CMDB_TEAMS_ERROR,
    },

    [actionTypes.SAVE_CMDB_TEAM]: {
        success: actionTypes.SAVE_CMDB_TEAM_SUCCESS,
        failure: actionTypes.SAVE_CMDB_TEAM_ERROR,
    },

    [actionTypes.TOGGLE_DEVICE_IMPORT]: false,
    [actionTypes.TOGGLE_ALL_DEVICES_IMPORT]: false,
    [actionTypes.TOGGLE_CONTACT_IMPORT]: false,
    [actionTypes.TOGGLE_ALL_CONTACTS_IMPORT]: false,
    [actionTypes.TOGGLE_TEAM_IMPORT]: false,
    [actionTypes.TOGGLE_ALL_TEAMS_IMPORT]: false,
    [actionTypes.SET_CMDB_IMPORT_CONTACT_TYPE]: false,
    [actionTypes.GET_OWNER_RESULTS]: {
        success: actionTypes.GET_OWNER_RESULTS_SUCCESS,
        failure: actionTypes.GET_OWNER_RESULTS_ERROR,
    },
    [actionTypes.GET_ACTION_LOGS]: {
        success: actionTypes.GET_ACTION_LOGS_SUCCESS,
        failure: actionTypes.GET_ACTION_LOGS_ERROR,
    },
    [actionTypes.GET_ALL_ACTION_LOGS]: {
        success: actionTypes.GET_ALL_ACTION_LOGS_SUCCESS,
        failure: actionTypes.GET_ALL_ACTION_LOGS_ERROR,
    },
    [actionTypes.GET_ALL_DECISION_LOGS]: {
        success: actionTypes.GET_ALL_DECISION_LOGS_SUCCESS,
        failure: actionTypes.GET_ALL_DECISION_LOGS_ERROR,
    },
    [actionTypes.GET_ALL_ISSUE_LOGS]: {
        success: actionTypes.GET_ALL_ISSUE_LOGS_SUCCESS,
        failure: actionTypes.GET_ALL_ISSUE_LOGS_ERROR,
    },
    [actionTypes.GET_ALL_ACTIVITY_LOGS]: {
        success: actionTypes.GET_ALL_ACTIVITY_LOGS_SUCCESS,
        failure: actionTypes.GET_ALL_ACTIVITY_LOGS_ERROR,
    },
    [actionTypes.RUNBOOK_ACTIONS_LOADING]: false,
    [actionTypes.FILTER_RUNBOOK_ACTIONS]: false,
    [actionTypes.ADD_NEW_ACTION]: false,
    [actionTypes.ADD_NEW_DEVICE]: false,
    [actionTypes.ADD_NEW_DECISION]: false,
    [actionTypes.ADD_NEW_ISSUE]: false,
    [actionTypes.ADD_SOLUTION_WITH_CHILDREN]: false,
    [actionTypes.EXPAND_ACTION]: false,
    [actionTypes.UPDATE_ACTION]: false,
    [actionTypes.MOVE_ACTION]: false,
    [actionTypes.MOVE_ACTIONS]: false,
    [actionTypes.DELETE_ACTION_START]: {
        success: actionTypes.DELETE_ACTION_END,
    },
    [actionTypes.DELETE_ACTION]: false,
    [actionTypes.FOCUS_ACTION]: false,
    [actionTypes.MARK_INFO_ONLY]: false,
    [actionTypes.UNMARK_FOR_DELETION]: false,
    [actionTypes.TOGGLE_FREEZE_OWNER]: false,
    [actionTypes.ADD_NEW_COMMENT]: {
        success: actionTypes.ADD_NEW_COMMENT_SUCCESS,
        failure: actionTypes.ADD_NEW_COMMENT_ERROR,
    },
    [actionTypes.OPEN_NEW_DOCUMENTATION_MODAL]: false,
    [actionTypes.CLOSE_NEW_DOCUMENTATION_MODAL]: false,
    [actionTypes.OPEN_EDIT_DOCUMENTATION_MODAL]: false,
    [actionTypes.CLOSE_EDIT_DOCUMENTATION_MODAL]: false,
    [actionTypes.SAVE_DOCUMENTATION]: {
        success: actionTypes.SAVE_DOCUMENTATION_SUCCESS,
        failure: actionTypes.SAVE_DOCUMENTATION_ERROR,
    },
    [actionTypes.DELETE_DOCUMENTATION]: {
        success: actionTypes.DELETE_DOCUMENTATION_SUCCESS,
        failure: actionTypes.DELETE_DOCUMENTATION_ERROR,
    },
    [actionTypes.GET_DOCUMENTATIONS]: {
        success: actionTypes.GET_DOCUMENTATIONS_SUCCESS,
        failure: actionTypes.GET_DOCUMENTATIONS_ERROR,
    },
    [actionTypes.GET_CUSTOMER_ZONES]: {
        success: actionTypes.GET_CUSTOMER_ZONES_SUCCESS,
        failure: actionTypes.GET_CUSTOMER_ZONES_ERROR,
    },
    [actionTypes.START_RUNBOOK_SESSION]: {
        success: actionTypes.START_RUNBOOK_SESSION_SUCCESS,
        failure: actionTypes.START_RUNBOOK_SESSION_FAILED,
    },
    [actionTypes.END_RUNBOOK_SESSION]: {
        success: actionTypes.END_RUNBOOK_SESSION_SUCCESS,
        failure: actionTypes.END_RUNBOOK_SESSION_FAILED,
    },
    [actionTypes.SELECT_RUNBOOK_WINDOW]: false,
    [actionTypes.GENERATE_RUNBOOK_CSV]: {
        success: actionTypes.GENERATE_RUNBOOK_CSV_SUCCESS,
        failure: actionTypes.GENERATE_RUNBOOK_CSV_ERROR,
    },
    [actionTypes.TOAST_SHOW]: false,
    [actionTypes.TOAST_REMOVE]: false,
    [actionTypes.SET_RUNBOOK_FORECAST]: false,
}

const DYNATRACE_SUCCESS_ACTIONS = {}
const DYNATRACE_FAILURE_ACTIONS = {}

Object.keys(DYNATRACE_ACTIONS).forEach((key) => {
    const dtAction = DYNATRACE_ACTIONS[key]
    if (typeof dtAction === 'object' && dtAction !== null) {
        if (dtAction.success) {
            DYNATRACE_SUCCESS_ACTIONS[dtAction.success] = key
        }
        if (dtAction.failure) {
            DYNATRACE_FAILURE_ACTIONS[dtAction.failure] = key
        }
    }
})

// This is a Redux internal event
const LOCATION_CHANGE_ACTION = '@@router/LOCATION_CHANGE'

// Tracking for dynatrace actions that have been sent, for later completion
if (!window.dynatraceActionIds) {
    window.dynatraceActionIds = {}
}

if (!window.backendLogContext) {
    window.backendLogContext = {}
}

/**
 * Logs Redux action details to the server, in order to get it into Splunk
 *
 * @param {Object} action - The Redux action being dispatched.
 * @param {string} userId - The user identifier, if already present in the state.
 */
const backendLog = (action, userId, validation) => {
    if (action.type === LOCATION_CHANGE_ACTION) {
        // if we change location assume we don't have a specific org/runbook anymore
        // the next GET_RUNBOOK_RECEIVED will get it again
        delete window.backendLogContext.organization
        delete window.backendLogContext.runbook
    }
    if (action.type === actionTypes.GET_RUNBOOK_RECEIVED) {
        window.backendLogContext.organization =
            action.data?.runbook?.organization
        window.backendLogContext.runbook = action.data?.runbook?.id
    }
    if (userId) {
        window.backendLogContext.userId = userId
    }

    if (validation) {
        window.backendLogContext.issuesFound = (validation?.issuesFound ?? []).length
        window.backendLogContext.status = (validation?.status ?? '')
    }

    fetch('/log', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type: action.type,
            tstamp: new Date().toISOString(),
            pathname: window.location.pathname,
            ...window.backendLogContext,
        }),
    })
        .then((response) => {
            if (!response.ok) {
                console.error('Failed to log to server')
            }
        })
        .catch((error) => {
            console.error('Error sending log to server:', error)
        })
}

/**
 * Logs actions to Dynatrace based on predefined actions in `DYNATRACE_ACTIONS`.
 * `dtrum` is the API for Dynatrace Real User Monitoring
 *
 * @param {Object} action - The Redux action being dispatched.
 */
const dynatraceLog = (action) => {
    let actionId

    if (DYNATRACE_ACTIONS.hasOwnProperty(action.type)) {
        const dtAction = DYNATRACE_ACTIONS[action.type]

        if (dtAction === false) {
            // this is in "immediate" action, which does not have a separate to signal completion or failure
            // therefore we call window.dtrum.enterAction and window.dtrum.leaveAction
            // this gets the action in Dynatrace, and immediately concludes it
            if (window.dtrum) {
                try {
                    actionId = window.dtrum.enterAction(
                        `Action Immediate: ${action.type}`
                    )
                    window.dtrum.leaveAction(actionId)
                    console.debug(`Instant Action: ${action.type}`)
                } catch {
                    console.error(
                        `Error happened while logging instant Action: ${JSON.stringify(
                            action
                        )}`
                    )
                }
            }
        } else if (typeof dtAction === 'object') {
            // this is an action to has a completion/error condition, so we start it here
            // we expect to receive a completion later
            // if not received, Dynatrace will give a default duration of 60+ seconds
            if (window.dtrum) {
                try {
                    actionId = window.dtrum.enterAction(
                        `Action: ${action.type}`
                    )
                    window.dynatraceActionIds[action.type] = actionId
                    console.debug(`Action: ${action.type}`)
                } catch {
                    console.error(
                        `Error happened while logging Action: ${JSON.stringify(
                            action
                        )}`
                    )
                }
            }
        }
    } else {
        if (DYNATRACE_SUCCESS_ACTIONS.hasOwnProperty(action.type)) {
            actionId =
                window.dynatraceActionIds[
                    DYNATRACE_SUCCESS_ACTIONS[action.type]
                ]
        } else if (DYNATRACE_FAILURE_ACTIONS.hasOwnProperty(action.type)) {
            actionId =
                window.dynatraceActionIds[
                    DYNATRACE_FAILURE_ACTIONS[action.type]
                ]
        }

        if (actionId && window.dtrum) {
            // completion of a previously started action
            try {
                window.dtrum.leaveAction(actionId)
                delete window.dynatraceActionIds[
                    DYNATRACE_SUCCESS_ACTIONS[action.type] ||
                        DYNATRACE_FAILURE_ACTIONS[action.type]
                ]
                console.debug(`Completion of Action: ${action.type}`)
            } catch {
                console.error(
                    `Error happened while logging Completion of Action: ${JSON.stringify(
                        action
                    )}`
                )
            }
        }
    }
}

// Middleware
const dispatchLog = (store) => (next) => (action) => {
    const state = store.getState()

    const activeRunbook = state?.ui?.runbook?.activeRunbook
    const activeRunbookData = activeRunbook ? state?.runbooks?.byId[String(activeRunbook)] : null
    const validation =  activeRunbookData?.actions?.validation

    backendLog(action, state?.app?.userId, validation)
    dynatraceLog(action)

    return next(action)
}

export default dispatchLog
